import React, { useMemo } from "react";
import Chart from "react-apexcharts";

// Genereert data in de vorm [{ x: Date, y: waarde }]
function prepareChartData(sensordata, type) {
  if (!Array.isArray(sensordata)) return { series: [] };

  const parsed = sensordata
    .map((item) => {
      const dateValue = item.datum || item.date;
      const value = item.value !== undefined ? item.value : item.meterstand;

      if (!dateValue || value === null || value === undefined) return null;

      let date;
      if (type === "maand") {
        date = new Date(`${dateValue}-01`);
      } else {
        date = new Date(dateValue);
      }

      return {
        x: date,
        y: parseFloat(value),
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.x - b.x);

  return {
    series: [
      {
        name: type === "uur" ? "kWh/uur" : type === "dag" ? "kWh/dag" : "kWh/maand",
        data: parsed,
      },
    ],
  };
}

export default function BarGraph({ sensor, kleur = "#008FFB", type }) {
  const chartData = useMemo(() => prepareChartData(sensor, type), [sensor, type]);

  const options = {
    chart: {
      type: "bar",
      height: 300,
      animations: { enabled: false },
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: [kleur],
    xaxis: {
      type: "datetime",
      labels: {
        datetimeUTC: false,
        format: type === "uur" ? "HH:mm" : type === "maand" ? "MMM-yy" : "dd-MM",
      },
      title: { text: "Datum" },
    },
    yaxis: {
      title: { text: "kWh" },
      labels: {
        formatter: function (val) {
          return Number(val).toFixed(3);
        },
      },
    },
    dataLabels: { enabled: false },
    tooltip: {
      x: {
        format: type === "uur" ? "HH:mm" : type === "maand" ? "MMM yyyy" : "dd MMM yyyy",
      },
      y: {
        formatter: function (val) {
          return Number(val).toFixed(3) + " kWh";
        },
      },
    },
  };

  if (!chartData.series.length || !chartData.series[0].data.length) {
    return (
      <div className="chart-no-data">
        <div className="alert alert-info">
          <i className="fas fa-info-circle"></i> Geen data beschikbaar voor {type} weergave
        </div>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <Chart options={options} series={chartData.series} type="bar" width="100%" height={300} />
    </div>
  );
}
